import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { QuotesApiService } from "./quotes-api.service";

@Injectable({ providedIn: "root" })
export class QuotesAccessGuard implements CanActivate {
  constructor(
    private readonly quotesApi: QuotesApiService,
    private readonly router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.quotesApi.verifyCurrentAccess().pipe(
      map(() => true),
      catchError((error: HttpErrorResponse) =>
        of(
          this.router.createUrlTree([
            error.status === 401 ? "/login" : "/dashboard",
          ]),
        ),
      ),
    );
  }
}
